import type { FaireProductEntity } from "../../entity_types/product";

export const p_9h6sfzfp4t: FaireProductEntity = {
  token: "p_9h6sfzfp4t",
  type: "product",
  name: "Wiggle Stripe Knit Grid Tee - Daybreak",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/fbbc813037a09f0e1c4c76d9aa48ea74cde6a6a383136ba09e139a7fcce9a2c6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/397b524ac40e63b5dc4f1ab787b364b23d04bfce5b35795e06f977b376bbe427.jpeg",
    "https://cdn.faire.com/fastly/2abec93f44abcac8c16d85aaa0ce992284d1a7f4cbace81d089c88c7d1be0a76.jpeg",
    "https://cdn.faire.com/fastly/ff709d833344752736d848bede9ce2662c88c92df061a340ec62ec751ca164f8.jpeg",
    "https://cdn.faire.com/fastly/704dd88b05217dd54b95ba339f57c24d03c393d6baa23d9d7d6402c4b6ef0ab5.jpeg",
    "https://cdn.faire.com/fastly/a516281787aede4b2cbacdc765944adff9739efa8dca0a2b8407ab31d93c6b2c.jpeg",
    "https://cdn.faire.com/fastly/09bc13cc30f8e5fff318a3a088356a23d5ebb4b56c5410e86fc806a0d707ec4c.jpeg",
    "https://cdn.faire.com/fastly/1dccc2a0e9377a459cec5f03c236c17018d3bc24a36dd9f380f445e6ae4669a5.jpeg",
    "https://cdn.faire.com/fastly/9f062a92e462e4aa0e110010c44b3a52c522f65dd9672ab02d30066808871241.jpeg",
    "https://cdn.faire.com/fastly/66c31b289cc063b90b64e7427819408cc02ca9fb685672eebb64f8d818256ca3.jpeg",
    "https://cdn.faire.com/fastly/3d3fc0b1f8ab76a4edbb8794adc8b0217ba44a75b1ea0a2d88fa2179b43601d0.jpeg"
  ],
  priceDollars: 71.1,
  description: "The Wiggle Stripe Tee has a relaxed shape that follows the body with a more fluid feel, created through its alternating rib structure. The surface shifts slightly as it moves, giving the silhouette a soft, wavy line. Lightweight and breathable, it sits comfortably on the body and feels easy to wear in warmer conditions.\n\nRather than relying on bold graphics, the texture carries the design. Alternating ribs create a gentle “wiggle” effect, adding subtle dimension and movement across the surface. The result is a piece that feels understated but dynamic. Pairing naturally with jeans, skirts, or shorts for everyday wear.\n\n• 100% cotton\n• Relaxed fit with a subtle wavy texture\n• Lightweight and breathable with a soft, flexible feel\n• Ideal for warm weather\n• Designed for spring and summer wear\n• Pairs well with jeans, skirts, or shorts",
  tags: [],
  msrpDollars: 158,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:23.423Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
